import { Injectable, OnInit } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
// import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate, OnInit {
  constructor(private router: Router) {}

  ngOnInit() {




 }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

      if (localStorage.getItem('supportName') !== '') {
         // alert(localStorage.getItem('supportName'));
        return true;
      } else {
      this.router.navigate(['/login']);
      return false;
      }


  }
}
